import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SpecialCharacterDirective } from './kb-special-character.directive';
import { NumberFormatDirective } from './number-format.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SpecialCharacterDirective, NumberFormatDirective],
  exports: [SpecialCharacterDirective, NumberFormatDirective],
})
export class KbDirectivesModule {}
